<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div v-html="html"></div>
</template>

<script setup lang="tsx">
import { defineProps } from 'vue';
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'normal-table-4';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
.normal-table-4 {
  thead {
    th {
      color: #fff;
      & > div {
        background-color: var(--theme-color-1);
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
      }
      & + th {
        & > div {
          margin-left: 6px;
        }
      }
    }
  }
  tbody {
    tr {
      td {
        & > div {
          border-left: 2pt solid var(--theme-color-1);
          border-right: 2pt solid var(--theme-color-1);
          border-bottom: 2pt solid var(--theme-color-1);
          position: relative;
        }
        & + td {
          & > div {
            margin-left: 6px;
          }
        }
      }
      // &:nth-child(even) {
      //   & > td > div {
      //     &::after {
      //       content: '';
      //       width: 100%;
      //       height: 100%;
      //       background-color: var(--theme-color-1);
      //       opacity: 0.1;
      //       position: absolute;
      //       left: 0;
      //       top: 0;
      //     }
      //   }
      // }
    }
  }
}
</style>
